import { useCallback, useState } from 'react';

type UseTaskCompletionParams = Readonly<{
	isCompleted: boolean;
	onCtaClick?: () => Promise<boolean>;
	onCheckboxChange?: () => Promise<void>;
}>;

type UseTaskCompletionReturn = Readonly<{
	isChecked: boolean;
	handleButtonClick: () => Promise<void>;
	handleCheckboxChange: (checked: boolean) => void;
}>;

export function useTaskCompletion({
	isCompleted,
	onCtaClick,
	onCheckboxChange,
}: UseTaskCompletionParams): UseTaskCompletionReturn {
	const [optimisticCompleted, setOptimisticCompleted] = useState(false);
	const isChecked = isCompleted || optimisticCompleted;

	const handleButtonClick = useCallback(async () => {
		if (onCtaClick) {
			await onCtaClick();
		} else if (onCheckboxChange) {
			setOptimisticCompleted(true);
			await onCheckboxChange();
		}
	}, [onCtaClick, onCheckboxChange]);

	const handleCheckboxChange = useCallback(
		(newValue: boolean) => {
			if (!newValue || !onCheckboxChange) return;
			setOptimisticCompleted(true);
			void onCheckboxChange();
		},
		[onCheckboxChange],
	);

	return { isChecked, handleButtonClick, handleCheckboxChange };
}
